import { executeGetEndpoint } from "./executGetEndpoint";

export const listProjects = async (jwtToken) => {

    const response = await executeGetEndpoint(jwtToken, 'listProjects');
    console.log(response);

    return response;
};